<template>
  <div class="app-container">
    <el-container>
      <div class="tabs_custom">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
          <el-tab-pane label="所有患者" name="first">
            <patientList v-if="activeName == 'first'"></patientList>
          </el-tab-pane>
          <el-tab-pane label="待管理患者" name="second">
            <patientContactList v-if="activeName == 'second'"></patientContactList>
          </el-tab-pane>
          <el-tab-pane label="我管理的" name="third">
            <patientMyList v-if="activeName == 'third'"></patientMyList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-container>
  </div>
</template>

<script>
import patientList from './patientList.vue';
import patientContactList from './patientContactList.vue';
import patientMyList from './patientMyList.vue'

export default {
  components: { patientList, patientContactList, patientMyList },
  props: {

  },
  data() {
    return {
      activeName: "first",
    };
  },
  created() {
  },
  methods: {
    // 点击切换tab标签页事件
    handleClick(target, action) {
      console.log(target.name, action)
      this.activeName = target.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.tabs_custom {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;

  ::v-deep {
    .el-tabs,
    .el-tab-pane {
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }

    .el-tabs__content {
      overflow-x: hidden !important;
    }
  }
}
</style>
